<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white rounded-lg mb-6 xl:mb-0 shadow-lg card-zoom"
    @mouseover="zoomIn" @mouseleave="zoomOut">
    <div class="flex-auto p-4">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-400 uppercase font-bold text-xs">
            {{ statSubtitle }}
          </h5>
          <span class="font-semibold text-xl text-blueGray-700">
            {{ statTitle }}
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full"
            :class="[statIconColor]"
          >
            <i :class="[statIconName]"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-zoom",
  methods: {
    zoomIn() {
      this.$el.style.transform = "scale(1.1)";
    },
    zoomOut() {
      this.$el.style.transform = "scale(1)";
    },
  },
  props: {
    statSubtitle: {      
    },
    statTitle: {   
    },
    statIconName: {
    },
    statIconColor: {
    },
  },
};
</script>
